/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AnalysisTypeSelector/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function AnalysisTypeSelector({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/PerformTrace/Content/Content/AnalysisTypeSelector",
  onChange
  
}) {
let cephAnalysisAnalysisTypesValueData = fromData.useDataValue({ viewPath,
context: 'ceph_analysis',
path: 'analysis_types',
})
let selectedAnalysisTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'analysis_type_id',
})
let selectedAnalysisTypeIdChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'analysis_type_id',
})
let selectedDisableActionsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'disable_actions',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="ceph_analysis.analysis_types"
 from={cephAnalysisAnalysisTypesValueData}
 data="selected.analysis_type_id"
 value={selectedAnalysisTypeIdValueData}
 onChange={selectedAnalysisTypeIdChangeData}
 maxWidth={350}
 width={350}
 marginTop={0}
 data="selected.disable_actions"
 disabled={selectedDisableActionsValueData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Analysis Type"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}